import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoadingController } from '@ionic/angular';
import { Router } from '@angular/router';
import { TokenService } from 'src/app/services/token.service';
import { AuthGuard } from 'src/app/guards/auth.guard';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  url = environment.api_url;

  userid: string = "";
  otp: string = "";

  state = 0;
  message = "";

  constructor(
    public http: HttpClient,
    private loadingController: LoadingController,
    private router: Router,
    private tokenService: TokenService
  ) {
    if (tokenService.currentAccessToken != null) {
      this.router.navigateByUrl('/', { replaceUrl: true });
    }
  }

  ngOnInit() {

  }

  fixNumbers = function (str) {

    let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g]
    let arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g]
    if (typeof str === 'string') {
      for (var i = 0; i < 10; i++) {
        str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
      }
    }
    return str;
  };

  async onReqOTP() {
    const loading = await this.loadingController.create();
    await loading.present();

    this.tokenService.requestCode(this.fixNumbers(this.userid)).subscribe(async data => {
      this.state = data.state;
      this.message = data.message;
      loading.dismiss();
      console.log(data);
    }, error => {
      console.error(error);
      loading.dismiss();
    })
  }

  async onSendOTP() {
    const loading = await this.loadingController.create();
    await loading.present();

    this.tokenService.sendCode(this.fixNumbers(this.userid), this.fixNumbers(this.otp)).subscribe(async data => {
      loading.dismiss();
      if (data[0] == true) {
        this.router.navigateByUrl('/', { replaceUrl: true });
      }
      else {
        this.message = data[1];
        this.state = 1;
      }
    }, error => {
      console.error(error);
      loading.dismiss();
    });
  }

  back(){
    this.state=0
  }

}
